import type { IconProps } from './types';

export const CheckGreenIcon: React.FC<IconProps> = (props) => {
    return (
        <svg {...props} id="icon-check" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <circle id="Ellipse_691" data-name="Ellipse 691" cx="12" cy="12" r="12" fill="none" opacity="0.1" />
            <rect id="Rectangle_45" data-name="Rectangle 45" width="24" height="24" fill="none" />
            <path
                id="Path_4"
                data-name="Path 4"
                d="M5.7,12.035l3.156,3.1,5.065-7.832"
                transform="translate(2.189 0.922)"
                fill="none"
                stroke="#00a720"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
            />
        </svg>
    );
};
